var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"c-section-header headline font-weight-black text-uppercase secondary--text"},[_c('span',{staticClass:"c-section-header__title-wrap mr-4"},[_vm._t("default",function(){return [_vm._v("Section Header")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }